import { TutorialsComponent } from './../tutorials/tutorial.component';
import { LeaderboardComponent } from './../leaderboard/leaderboard.component';
import { SubscriptionInfoComponent } from './../subscription-packages/subscription-info/subscription-info.component';
import { BillingInfoComponent } from './../checkout/components/billing-info.component';
import { PaymentFlowComponent } from './../payment-flow/payment-flow.component';
import { StatisticsComponent } from './../statistics/statistics.component';
import { OverallComponent } from './../statistics/overall/overall.component';
import { RevisionPapersComponent } from './../statistics/revision-papers/revision-papers.component';
import { OnlineExamsComponent } from './../statistics/online-exams/online-exams.component';
import { TermTestsComponent } from './../statistics/term-tests/term-tests.component';
import{ RegistrationPaymenntComponent } from './../registration/registration-paymennt/registration-paymennt.component';
import{WijayaNewsComponent} from '../wijaya-news/wijaya-news.component';

import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
/**
 * Main moduls import
 */
import { HomeComponent } from './components/home.component';
import { VerifyComponent } from './components/verify.component';
import {
  PaperSetsComponent,
  MainComponent,
  PapersComponent,
  PaperPartsComponent,
  PaperComponent,
  // RegistrationPaymenntComponent,
} from '../paper-sets/';
import {
  ReportComponent,
  ReportMainComponent,
  ReportPapersComponent,
  ReportPartsComponent,
  ReportSummaryComponent,
  ReportReviewComponent
} from '../report/';
import {
  ActivityComponent,
  ActivityMainComponent
} from '../activity/';
import { ErrorInternetComponent } from '../../shared';
import { LessonsComponent } from '../lessons/';
import { PaymentComponent } from '../payment/';
import { SettingComponent } from '../setting/';
import { TestComponent } from '../test/';
import { InstructionsComponent } from '../instructions/';
import { StaffComponent } from '../staff/';
import { LoginGuardService } from '../login/services/login-guard.service';
import { PendingChangesGuard } from '../login/services/route-deactivate';
import { CheckoutComponent } from '../checkout/';

// Route Configuration
const homeRoutes: Routes = [
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full',
    canDeactivate: [PendingChangesGuard]
  },
  { path: 'verify/:_verify', component: VerifyComponent },
  {
    path: 'home', component: HomeComponent,
    children: [
      { path: '', component: PaperSetsComponent },
      {
        path: 'exams', component: MainComponent,
        children: [
          { path: '', component: PaperSetsComponent },
          { path: ':filter', component: PaperSetsComponent },
          { path: ':setid/papers', component: PapersComponent },
          { path: 'papers/:paperid/parts', component: PaperPartsComponent },
          // {path:':setid/payment',component: PaymentComponent},
          { path: 'papers/parts/:partid/questions', component: PaperComponent, canActivate: [LoginGuardService], canDeactivate: [PendingChangesGuard] }]
      },
      {
        path: 'pay', component: PaymentFlowComponent,
        children: [
          { path: 'checkout', component: CheckoutComponent },
          { path: 'billing-info', component: BillingInfoComponent },
          { path: 'payment-options', component: PaymentComponent },
          { path: 'payment-options/:paymentcode', component: PaymentComponent },
          { path: 'payment-options/payment/:token', component: PaymentComponent },
        ]
      },
      {
        path: 'dialog-subscription-info', component: SubscriptionInfoComponent,
        children: [
          { path: ':token', component: SubscriptionInfoComponent },
        ]
      },
      {
        path: 'reports', component: ReportMainComponent,
        children: [{ path: '', component: ReportComponent },
        { path: ':setid/papers', component: ReportPapersComponent },
        { path: 'papers/:paperid/parts', component: ReportPartsComponent },
        //{path:'papers/:partid/summary',component: ReportSummaryComponent},
        { path: 'papers/:partid/summary', component: ReportReviewComponent },
        { path: 'papers/:partid/summary/review/:categoryid/:subject', component: ReportReviewComponent }]
      },
      { path: 'activity', component: ActivityComponent },
      { path: 'lessons', component: LessonsComponent },
      { path: 'instructions', component: InstructionsComponent },
      { path: 'arts', component: StaffComponent },
      { path: 'err_internet', component: ErrorInternetComponent },
      { path: 'settings', component: SettingComponent, },
      { path: 'test', component: TestComponent },
      { path: 'test1', component: SettingComponent },
      { path: 'checkout', component: CheckoutComponent },
      { path: 'wijayanews', component: WijayaNewsComponent },
      { path: 'tutorials', component: TutorialsComponent },
      { path: 'leaderbaord', component: LeaderboardComponent },

      {
        path: 'statistics', component: StatisticsComponent ,
        children: [
          {
            path: '',pathMatch: 'full',redirectTo: 'overall'
          },
          {
            path: 'overall', component: OverallComponent
          },
          {
            path: 'papers', component: RevisionPapersComponent,
          },
          {
            path: 'papers/:id', component: RevisionPapersComponent,
          },
          { path: 'online-exams', component: OnlineExamsComponent },
          { path: 'online-exams/:id', component: OnlineExamsComponent },
          { path: 'term-tests', component: TermTestsComponent },
          { path: 'term-tests/:id', component: TermTestsComponent },
        ]
      },
      {
        path: 'registration', component: MainComponent,
        children: [
          { path: '', component: RegistrationPaymenntComponent },
          { path: 'registration-payment/:token', component: RegistrationPaymenntComponent },
          ]
      }
    ],
  },
  //   { path: 'home', component: HomeComponent ,
  //   children:[ {path:'exams',component: MainComponent,
  //              children:[{path:'',component: PaperSetsComponent},
  //                        {path:':setid/papers',component: PapersComponent},
  //                        {path:'papers/:paperid/parts',component: PaperPartsComponent},
  //                        {path:':setid/payment',component: PaymentComponent},
  //                        {path:'papers/parts/:partid/questions',component: PaperComponent, canActivate: [LoginGuardService], canDeactivate: [PendingChangesGuard] }]},
  //                 {path:'reports',component: ReportMainComponent,
  //                 children:[{path:'',component: ReportComponent},
  //                           {path:':setid/papers',component: ReportPapersComponent},
  //                           {path:'papers/:paperid/parts',component: ReportPartsComponent},
  //                           {path:'papers/:partid/summary',component: ReportSummaryComponent},
  //                           {path:'papers/:partid/summary/review/:categoryid/:subject',component: ReportReviewComponent}]},
  //                 {path:'activity',component: ActivityComponent},
  //                 {path:'lessons',component: LessonsComponent},
  //                 {path:'instructions',component: InstructionsComponent},
  //                 {path:'staff',component: StaffComponent},
  //                 {path:'err_internet',component: ErrorInternetComponent},
  //                 {path:'settings',component: SettingComponent , },
  //                 {path:'test',component: TestComponent},
  //                 {path:'test1',component: SettingComponent} ,
  //                 {path:'checkout',component: CheckoutComponent , }]
  // },
  { path: '**', redirectTo: '' }
];

export const homeRoutingProviders: any[] = [
  TranslateService
];

export const homeRouting: ModuleWithProviders = RouterModule.forChild(homeRoutes);



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/home/home.routes.ts